import { ChangeDetectionStrategy, Component, computed, inject, model, output } from '@angular/core';
import { DsTooltipDirectiveModule, TooltipConfig } from '@bmw-ds/components';

import { CommunicationField } from '../../../customer/model/communication-field.model';
import { FeatureVisibilityService } from '../../../customer/services/feature-visibility.service';
import { InputPhoneNumberComponent } from '../../../form/components/input-phone-number/input-phone-number.component';
import { useI18n } from '../../../i18n/services/i18n.service';
import { SearchFormService } from '../../search-form.service';

@Component({
  selector: 'cdf-phone-search',
  imports: [DsTooltipDirectiveModule, InputPhoneNumberComponent],
  host: {
    class: 'd-flex gap-2x',
  },
  template: `
    <cdf-input-phone-number
      id="mobile-phone"
      [placeholder]="i18n('placeholder.mobilePhone')"
      [(model)]="mobilePhone"
      [displayError]="displayMobilePhoneError()"
      [attr.title]="displayMobilePhoneError() ? '' : undefined"
      [disabled]="!!phone()"
      [ds-tooltip]="
        displayMobilePhoneError() ? i18n('customerInformationDialog.error.invalidPhone') : i18n('onlyPhoneXorMobile')
      "
      [dsTooltipConfig]="disabledMobilePhoneTooltipConfig()"
      [hidden]="featureVisibilityService.isHidden(CommunicationField.MOBILE_PHONE)"
      validateWhenTouchedOnly
    />
    <cdf-input-phone-number
      id="phone"
      [placeholder]="i18n('placeholder.landline')"
      [(model)]="phone"
      [displayError]="displayPhoneError()"
      [attr.title]="displayPhoneError() ? '' : undefined"
      [disabled]="!!mobilePhone()"
      [ds-tooltip]="
        displayPhoneError() ? i18n('customerInformationDialog.error.invalidPhone') : i18n('onlyPhoneXorMobile')
      "
      [dsTooltipConfig]="disabledPhoneTooltipConfig()"
      [hidden]="featureVisibilityService.isHidden(CommunicationField.PHONE)"
      validateWhenTouchedOnly
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneSearchComponent {
  protected readonly i18n = useI18n();
  readonly featureVisibilityService = inject(FeatureVisibilityService);
  readonly searchFormService = inject(SearchFormService);

  readonly phone = model.required<string | undefined>();
  readonly mobilePhone = model.required<string | undefined>();

  readonly readonly = output();

  protected readonly disabledPhoneTooltipConfig = computed<TooltipConfig>(() => ({
    origin: 'bottom',
    disabled: !this.mobilePhone() && !this.displayPhoneError(),
  }));
  protected readonly disabledMobilePhoneTooltipConfig = computed<TooltipConfig>(() => ({
    origin: 'bottom',
    disabled: !this.phone() && !this.displayMobilePhoneError(),
  }));

  protected readonly CommunicationField = CommunicationField;

  protected displayMobilePhoneError() {
    return !!this.mobilePhone() && !this.searchFormService.isMobilePhoneValid();
  }

  protected displayPhoneError() {
    return !!this.phone() && !this.searchFormService.isPhoneValid();
  }
}
